import { getAuthHeaders } from "../../../shared/services/authentication";
import { BASE_URL } from "../../../shared/utils/variables";
import { Lancamento } from "../../../shared/interfaces/lancamento";

const baseURL = BASE_URL;

export const fetchTiposLancamento = async (): Promise<Lancamento[]> => {
    const url = `${baseURL}/lancamentos`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status} - ${response.statusText}`);
        }

        const data: unknown = await response.json();

        return data as Lancamento[];
    } catch (error) {
        console.error("Erro ao buscar lançamentos:", error);
        return [];
    }
};
